import { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { ROUTES } from '@constants/index'
import { AppErrorType } from '@typesApp/AppError'
import { useAppNavigate } from '@hooks/useAppNavigate'
import { usePathBuilder } from '@hooks/usePathBuilder'
import { ErrorContentOptions, ErrorCtaOptions, ErrorPageState } from '../types'
import { setAppError } from '@redux/slices'

type ErrorPageOptions = {
  errorType?: AppErrorType
  ctaOptions?: ErrorCtaOptions
  contentOptions?: ErrorContentOptions
}

type UseErrorPageReturn = {
  showErrorPage: (options?: ErrorPageOptions) => void
}

export const useErrorPage = (): UseErrorPageReturn => {
  const dispatch = useDispatch()
  const navigate = useAppNavigate()
  const buildPath = usePathBuilder()

  const showErrorPage = useCallback(
    (options?: ErrorPageOptions) => {
      const { errorType, ctaOptions, contentOptions } = options ?? {}

      // NOTE: we cannot serialize callbacks in the navigate state so need to use redux
      if (typeof ctaOptions?.ctaOnClick === 'function') {
        dispatch(
          setAppError({
            errorType,
            ctaCallback: ctaOptions.ctaOnClick,
          })
        )
      }

      const state: ErrorPageState = {
        errorType,
        title: contentOptions?.title,
        message: contentOptions?.message,
        ctaLabel: ctaOptions?.ctaLabel,
      }

      navigate(buildPath(ROUTES.ERROR), { state })
    },
    [dispatch, navigate, buildPath]
  )

  return {
    showErrorPage,
  }
}
